<template>
  <div
    :class="`header-row font-weight-light ${color?color:''}`"
    :style="`
    z-index: ${z_index};
    left: ${sticky_left};

    ${width?`width: ${width};`:''}
    `"
    >
    <!-- border-color: ${border_color?`${border_color} !important`:'var(--header_border_color) !important'}; -->
    <!-- border-width: ${border_width?border_width:(border_color?`1px 1px 1px 1px`:`0px 1px 1px 0px`)}; -->
    <div class="top-center">
      <slot name="top-center"/>
    </div>
    <div class="middle-left">
      <slot name="middle-left"/>
    </div>
    <div class="middle-right">
      <slot name="middle-right"/>
    </div>
    <div class="bottom-center">
      <slot name="bottom-center"/>
    </div>
    <input
      class="input-field"
      ref="inputfield"
      :value="text"
      @keyup.enter="$refs.inputfield.blur()"
      @blur="$emit('changeValue', $event.target.value)"
      :disabled="readonly"
      :style="`
      ${inner_border?`border: ${inner_border}`:''}
      color: ${text_color?text_color:''};
      ${text_color == 'primary'?'color: var(--v-primary-base);':''};
      `"
      />
      <div class="description-field" v-if="description" :style="`color: ${border_color}`">
        <TTooltip :value="description">
          <TText :text="description" :max_lines="1" />
        </TTooltip>
      </div>
      <!-- @mouseleave="$refs.inputfield.blur()" -->
      <div v-if="unit">{{unit}}</div>
  </div>
</template>
<script>
export default {
  props: [
    'z_index',
    'sticky_left',
    'text',
    'readonly',
    'unit',
    'color',
    'border_color',
    'text_color',
    'width',
    'border_width',
    'inner_border',
    'description'
  ],
  data: () => ({
  }),
}
</script>
<style>
  .header-row {
    position: sticky;
    position: -webkit-sticky;
    display: flex;
    width: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom));
    height: calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom));
    padding: calc(5px * var(--taktplan_zoom));
    background-color: #121212;
    /* background-color: var(--v-color-4-base); */
    /* border-style: dotted; */
    /* border-color: var(--header_border_color); */
    /* border-width: 0px 1px 1px 0px; */
    justify-content: center;
    align-items: center;
    /* box-shadow: 1px 2px 0px 1px #000000; */
    will-change: 'left';
    flex-shrink: 0;
  }
  .input-field {
    min-width: 75%;
    cursor: inherit;
    padding: 1px 3px 1px 3px;
    height: 100%;
    flex: 1 1 0px;
    font-size: calc(16px * var(--taktplan_zoom));
  }
  .top-center {
    position: absolute;
    left: 50%;
    top: 0px;
    will-change: 'width';
  }
  .middle-left {
    position: absolute;
    left: 0px;
    top: 50%;
    will-change: 'width';
  }
  .middle-right {
    position: absolute;
    right: 0px;
    top: 50%;
    will-change: 'width';
  }
  .bottom-center {
    position: absolute;
    left: 50%;
    bottom: 0px;
    will-change: 'width';
  }

  .description-field {
    border-bottom: 1px solid;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0px 4px;
    /* width: 20%; */
    /* flex-grow: 1; */
    flex: 1 1 0px;
  }
</style>
